/**
 * Fragment de routes du paquet v9-p01-paliers (vague V9 ; fragment `v9-<sous>` par paquet, constat K11 de la fiche V9).
 * Composants chargés à la demande (règle de chargement du registre). Routes neuves :
 *  - `/plateforme/paliers` → plateforme-paliers ;
 *  - `/plateforme/paliers/nouveau` et `/plateforme/paliers/:palierId/brouillon` → dialogue-palier ;
 *  - `/plateforme/paliers/:palierId` → plateforme-palier-fiche ;
 *  - `/org/abonnement/paliers` → organisation-paliers-comparer.
 * Les écrans de plateforme reçoivent `superAdmin` (rôle de plateforme de la session) : le contexte de la règle de
 * plateforme en dépend, comme la garde serveur `GardePaliers`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const PlateformePaliers = lazy(() => import('../ecrans/v9/paliers/PlateformePaliers'))
const PlateformePalierFiche = lazy(() => import('../ecrans/v9/paliers/PlateformePalierFiche'))
const DialoguePalier = lazy(() => import('../ecrans/v9/paliers/DialoguePalier'))
const OrganisationPaliersComparer = lazy(() => import('../ecrans/v9/paliers/OrganisationPaliersComparer'))

function ecran(Composant: ComponentType<{ session: Session; superAdmin?: boolean }>) {
  return ({ session, superAdmin, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} superAdmin={superAdmin} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v9-paliers',
  routes: [
    { chemin: '/plateforme/paliers', element: ecran(PlateformePaliers) },
    { chemin: '/plateforme/paliers/nouveau', element: ecran(DialoguePalier) },
    { chemin: '/plateforme/paliers/:palierId', element: ecran(PlateformePalierFiche) },
    { chemin: '/plateforme/paliers/:palierId/brouillon', element: ecran(DialoguePalier) },
    { chemin: '/org/abonnement/paliers', element: ecran(OrganisationPaliersComparer) },
  ],
}
